// extracted by mini-css-extract-plugin
module.exports = {"footer":"AdvertisementModal_footer__2a6HM","header":"AdvertisementModal_header__3TfWU","check":"AdvertisementModal_check__3pPbn","copyright":"AdvertisementModal_copyright__8_oKc"};